import { Button } from '@playbooks/ui/components/button';
import { Icon } from '@playbooks/ui/components/icon';

const ComposerVoiceAction = ({ active = false, disabled = false, onClick }) => {
	return (
		<Button variant='outline' disabled={disabled} size='icon-xs' aria-label='Start dictation' onClick={onClick}>
			<Icon data-icon='inline-start' type='far' icon={active ? 'microphone-slash' : 'microphone'} aria-hidden />
		</Button>
	);
};

export { ComposerVoiceAction };
